import { Flex } from '@amzn/storm-ui';

import { CustomCard } from '../../../UiComponentsLibrary/CustomCard';
import { CustomSnackbar } from '../../../UiComponentsLibrary/CustomSnackbar';
import {
    SnackbarVariants
} from '../../../UiComponentsLibrary/CustomSnackbar/constants/snackbarVariants';
import CurrentFormRenderer from './components/CurrentFormRenderer';
import ModalFooter from './components/ModalFooter';
import { useBookingDataOperations } from './hooks/useBookingDataOperations';
import { CreateBookingModalProps } from './interface/DetailedBookingInterface';

export const CreateBookingPage = (props: CreateBookingModalProps) => {
    const {
        modalHeader,
        currentStep,
        buttonConfig,
        successMessage,
        formRenderProps,
        handleCloseSnackBar,
    } = useBookingDataOperations(props);

    return (
        <>
            <CustomCard id="create-booking-card" title={modalHeader}>
                <CurrentFormRenderer {...formRenderProps} />
                <Flex justifyContent="flex-end" padding="xsmall" columnGap="small">
                    <ModalFooter buttonConfig={buttonConfig} currentStep={currentStep} />
                </Flex>
            </CustomCard>
            <CustomSnackbar
                variant={SnackbarVariants.SUCCESS}
                message={successMessage}
                isVisible={!!successMessage}
                onClose={handleCloseSnackBar}
            />
        </>
    );
};

export default CreateBookingPage;
